import { useMemo } from 'react';

export interface UrlParams {
    openSettings: string | null;
    summaryMode: string | null;
    startParam: string | null;
    screen: string | null;
    zoom: number | null;
}

export const useUrlParams = (): UrlParams => {
    return useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const telegramStartParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param;
        const urlStartApp = urlParams.get("startapp");

        // Считываем и валидируем параметр zoom
        const zoomParam = urlParams.get("zoom");
        let zoom: number | null = null;

        if (zoomParam) {
            const parsedZoom = parseFloat(zoomParam);
            // Валидируем зум: должен быть числом от 1 до 20
            if (!isNaN(parsedZoom) && parsedZoom >= 1 && parsedZoom <= 20) {
                zoom = parsedZoom;
            }
        }

        return {
            openSettings: urlParams.get("openSettings"),
            summaryMode: urlParams.get("summaryMode"),
            startParam: telegramStartParam || urlStartApp || null,
            screen: urlParams.get("screen"),
            zoom,
        };
    }, []);
};

export const clearUrlParams = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("summaryMode");
    url.searchParams.delete("openSettings");
    url.searchParams.delete("screen");
    window.history.replaceState({}, document.title, url.toString());
};